/* Both product families share the same mutation lock and checkout validation. */
(()=>{
 async function get(){await window.SouvenirMagnets.get();return window.SouvenirPints.get();}
 window.SouvenirCart={get};
 window.SouvenirCheckout=async()=>{
  await get();
  return navigator.locks.request('souvenir-cart',async()=>{
   const m=window.SouvenirMagnets,p=window.SouvenirPints;
   const response=await fetch(`${m.config.root}cart.js`,{cache:'no-store',credentials:'same-origin'});
   if(!response.ok)throw Error('Please check your cart again.');
   const cart=await response.json(),magnets=m.inspect(cart,await m.catalog()),pints=p.inspect(cart,await p.catalog());
   if(!cart.item_count)throw Error('Your cart is empty.');
   if(magnets.invalid.length||pints.invalid.length)throw Error('Review incomplete design selections before checkout.');
   for(const [found,expected] of [[magnets,m.total(magnets.magnets.length)],[pints,p.total(pints.glasses.length,pints.double)]]){
    if(found.lines.reduce((sum,l)=>sum+l.original_price*l.quantity,0)!==expected)throw Error('Your cart changed. Check prices again before checkout.');
   }
   if(pints.glasses.length&&!p.config.checkoutReady)throw Error('Glass checkout is being prepared. Your selection is saved; ordering will open once shipping is ready.');
   location.assign(`${m.config.root}checkout`);
  });
 };
 window.addEventListener('souvenir:cart-updated',async event=>{
  try{const m=window.SouvenirMagnets,p=window.SouvenirPints;if(!m||!p)return;const mf=m.inspect(event.detail,await m.catalog()),pf=p.inspect({items:mf.others},await p.catalog());const count=mf.magnets.length+pf.glasses.length+pf.others.reduce((n,l)=>n+l.quantity,0);document.querySelectorAll('[data-header-cart-count]').forEach(el=>{el.dataset.headerCartCount=count||'';el.classList.toggle('visible',count>0);});}catch(_){/* Cart page displays validation errors. */}
 });
})();
